import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'

import builderReducer from './builderReducer.js';
import authReducer from './authReducer.js';
import chatReducer from './chatReducer.js';
import generalReducer from './generalReducer.js';
import appReducer from './appReducer.js';
import builderPopupReducer from './builderPopupReducer.js';
import segmentReducer from './segmentReducer.js';

const rootReducer = combineReducers({
	routing: routerReducer,
	builder: builderReducer,
	auth: authReducer,
	chat:chatReducer,
	general:generalReducer,
	form: formReducer,
	app:appReducer,
	builderPopup:builderPopupReducer,
	segments:segmentReducer,
})


export default rootReducer


// WEBPACK FOOTER //
// ./reducers/index.js